"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../../shared"));

var _NotificationsFooter = _interopRequireDefault(require("./NotificationsFooter"));

var _NotificationsItem = _interopRequireDefault(require("./NotificationsItem"));

var _Icon = _interopRequireDefault(require("../../Icon/Icon"));

var _Responsive = _interopRequireDefault(require("../../Responsive/Responsive"));

var _NotificationsDropdown = _interopRequireDefault(require("./NotificationsDropdown"));

var _NotificationsModal = _interopRequireDefault(require("./NotificationsModal"));

var _ModalContext = require("./ModalContext");

var _DropdownContext = require("./DropdownContext");

require("./Notifications.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
notifications dropdown or modal for header bar
*/
function HeaderBarNotifications(_ref) {
  var on = _ref.on,
      emptyMessage = _ref.emptyMessage,
      title = _ref.title,
      children = _ref.children,
      onToggle = _ref.onToggle,
      className = _ref.className,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["on", "emptyMessage", "title", "children", "onToggle", "className"]);

  var cssClasses = ['st_headerbar__item', 'st_headerbar__notifications'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);

  var trigger = /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_headerbar__alert " + (on && 'st_headerbar__alert--on')
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "bell",
    alt: "notifications",
    color: "ink"
  }));

  var items = _react["default"].Children.map(children, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    if (child.type.displayName === 'HeaderBar.Notifications.Item') {
      return child;
    }

    return null;
  });

  var footer = _react["default"].Children.map(children, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    if (child.type.displayName === 'HeaderBar.Notifications.Footer') {
      return child;
    }

    return null;
  });

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps), /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    xs: true
  }, /*#__PURE__*/_react["default"].createElement(_ModalContext.ModalProvider, {
    onToggle: onToggle
  }, /*#__PURE__*/_react["default"].createElement(_NotificationsModal["default"], {
    emptyMessage: emptyMessage,
    title: title,
    trigger: trigger,
    items: items,
    footer: footer
  }))), /*#__PURE__*/_react["default"].createElement(_Responsive["default"], {
    sm: true,
    md: true,
    lg: true
  }, /*#__PURE__*/_react["default"].createElement(_DropdownContext.DropdownProvider, {
    onToggle: onToggle
  }, /*#__PURE__*/_react["default"].createElement(_NotificationsDropdown["default"], {
    emptyMessage: emptyMessage,
    title: title,
    trigger: trigger,
    items: items,
    footer: footer
  }))));
}

HeaderBarNotifications.propTypes = {
  /** is the bell on? */
  on: _propTypes["default"].bool,

  /** message to display when there are no notifications */
  emptyMessage: _propTypes["default"].string,

  /** title for box */
  title: _propTypes["default"].string,

  /** what to do when dropdown/modal is opened or closed, returns final open state */
  onToggle: _propTypes["default"].func,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps
};
HeaderBarNotifications.defaultProps = {
  title: 'Notifications',
  on: false,
  emptyMessage: null,
  onToggle: null,
  className: null
};
HeaderBarNotifications.displayName = 'HeaderBar.Notifications';
HeaderBarNotifications.Item = _NotificationsItem["default"];
HeaderBarNotifications.Footer = _NotificationsFooter["default"];
var _default = HeaderBarNotifications;
exports["default"] = _default;